module.exports = __webpack_public_path__ + "img/product2.b9318a2f.png";